import moment from "moment";
import i18n from '../languages/i18n.js';


export function dateToNow(date, lang) {
  // lang = lang ? lang : 'zh'
  // date = new Date(date).getTime();
  // const now = Date.now();
  // const today = new Date(new Date().format('yyyy-MM-dd')).getTime();
  // const time = now - date;
  // const timeZero = today - date;
  // const dayTime = 60 * 60 * 1000 * 24;
  // const day = Math.abs(Math.ceil(timeZero / dayTime));
  // const year = new Date().getFullYear();
  // const lastYear = new Date(date).getFullYear();
  // let text = '';
  // if (time > 0) {
  //   if (date >= today) {
  //     if (date - today <= 60 * 1000) {
  //       text = `${Math.round(now - date) / 1000}${lang === 'zh' ? '秒前' : ' seconds ago'}`
  //     } else if (60 * 1000 * 60 > now - date && now - date >= 60 * 1000) {
  //       text = `${Math.round((now - date) / 60000)}${lang === 'zh' ? '分钟前' : ' minutes ago'}`
  //     } else if (60 * 1000 * 60 <= now - date) {
  //       text = `${Math.round((now - date) / 3600000)}${lang === 'zh' ? '小时前' : ' hours ago'}`
  //     }
  //   } else if (date < today && date > today - dayTime) {
  //     text = lang === 'zh' ? '昨天' : 'yesterday'
  //   } else if (date > today - 7 * dayTime) {
  //     text = `${day}${lang === 'zh' ? '天前' : ' days ago'}`;
  //   } else if (year == lastYear) {
  //     text = new Date(date).format('MM-dd');
  //   } else {
  //     text = new Date(date).format('yyyy-MM-dd');
  //   }
  // } else {
  //   //几天后
  //   //待扩展 
  // }
  // return text;

  lang = lang ? lang : 'zh';
  var now = new Date().getTime(),
    diffValue = now - date,
    result = '',
    minute = 1000 * 60,
    hour = minute * 60,
    day = hour * 24,
    halfamonth = day * 15,
    month = day * 30,
    year = month * 12,

    _year = diffValue / year,
    _month = diffValue / month,
    _week = diffValue / (7 * day),
    _day = diffValue / day,
    _hour = diffValue / hour,
    _min = diffValue / minute;
  const year1 = new Date().getFullYear();
  const lastYear = new Date(date).getFullYear();
  if (lastYear < year1) result = new Date(date).format('yyyy-MM-dd');  //"几年前"
  else if (lastYear == year1 && _week >= 1) result = new Date(date).format('MM-dd');  //"几个月前"
  else if (_day >= 1) result = `${parseInt(_day)}${lang === 'zh' ? '天前' : ' days ago'}`;
  else if (_hour >= 1) result = `${parseInt(_hour)}${lang === 'zh' ? '小时前' : ' hours ago'}`;   //"给小时前"
  else if (_min >= 1) result = `${parseInt(_min)}${lang === 'zh' ? '分钟前' : ' minutes ago'}`;  //"分钟前"
  else result = `${lang === 'zh'?'刚刚':'now'}`; //"刚刚"
  return result;
}

/**
 * 隐藏手机号/邮箱关键信息
 */
export function accountCut(value, type) {
  let _value;
  if (typeof value !== "string") {
    _value = String(value);
  } else {
    _value = value;
    if (type === "email") {
      var regEmail = null;
      if (value.split('@').length) {
        var arr = value.split('@')[0];
        if (arr.length > 5) {
          regEmail = arr.slice(0,3) + '****' + arr.slice(arr.length-2,arr.length) + '@' + value.split('@')[1];
          return regEmail
        } else {
          regEmail = arr.substring(0,1) + '****' + '@' + value.split('@')[1]
          return regEmail
        }
      }
      
    } else if (type === "phone") {
      const regPhone = /(\d{3})(\d)*(\d{4})/;
      return _value.replace(regPhone, (a, b, c, d) => {
        return `${b}****${d}`
      })
    } else {
      return value;
    }
  }
}

export function formatDate(value, format) {
  if (value === "-") {
    return value;
  }
  if (!value) return "";
  if (!format) format = "YYYY-MM-DD HH:mm:ss";
  if (/^\d*$/.test(value)) {
    value = parseInt(value);
  }
  return moment(value).format(format);
}

export function subStr(value, length) {
  let result = value.length > length;
  return result ? value.substr(0, length) + "..." : value;
}

export function numToPrice(value) {
  return value ? "￥" + value.toLocaleString("en") : value === 0 ? value : i18n.t('global.暂无');
}

export function videoUrl(value) {
  if (!value || value === "") return value;
  if (value.indexOf("http://") > -1 || value.indexOf("https://") > -1) {
    return value;
  } else {
    return `https://video.manamana.net/${value}`;
  }
}

export function isHtml(value) {
  if (value.indexOf('<') != -1 && value.indexOf('>') != -1) {
    return true;
  } else {
    return false;
  }
}

export function download(value, title) {
  return value + "?attname=" + title + ".mp4";
}
export function personBgImageUrl(value, defaultImg) {
  value = encodeURI(value);
  if (!value || value === 'undefined') {
    value = defaultImg;
  }
  let bg = "";
  if (value.indexOf("http://") > -1 || value.indexOf("https://") > -1) {
    bg = value;
  } else {
    let url = `https://image.manamana.net/${value}`;
    bg = url;
  }
  var obj = {
    backgroundSize: 'cover', backgroundPosition: 'center'
  };
  obj.backgroundImage = "url('" + bg + "')";
  return obj;
}

export function bgImageUrl(value, defaultImg, width, height) {
  value = encodeURI(value);
  if (!value || value === 'undefined') {
    return defaultImg;
  }
  let bg = "";
  if (value.indexOf("http://") > -1 || value.indexOf("https://") > -1) {
    if (width && height && value.indexOf("/w/") == -1) {
      if (value.indexOf('imageMogr2/') > -1) {
        bg = `${value.split('?')[0]}?imageView2/1/w/${width}/h/${height}/format/jpg`;
      } else {
        if (value.indexOf("?") > -1) {
          bg = `${value}&imageView2/1/w/${width}/h/${height}/format/jpg`;
        } else {
          bg = `${value}?imageView2/1/w/${width}/h/${height}/format/jpg`;
        }
      }
    } else if (width && height && value.indexOf("/w/") != -1) {
      let end = value.indexOf("/w/");
      let str = value.substr(0, end) + `/w/${width}/h/${height}/format/jpg`;
      if (str.indexOf('video.manamana.net') != -1 && str.indexOf('image.manamana.net') != -1) {
        bg = str.replace('https://image.manamana.net/', '')
      } else {
        bg = str
      }
    }
    else {
      bg = value;
    }
  } else {
    let url = `https://image.manamana.net/${value}`;
    if (width && height) {
      if (url.indexOf('imageMogr2/') > -1) {
        url = url.split('?')[0];
      }
      if (url.indexOf("?") > -1) {
        bg = `${url}&imageView2/1/w/${width}/h/${height}/format/jpg`;
      } else {
        bg = `${url}?imageView2/1/w/${width}/h/${height}/format/jpg`;
      }
    } else {
      bg = url;
    }
  }
  var obj = {};
  obj.backgroundImage = "url('" + bg + "')";
  return obj;
}

export function imageUrl(value, defaultImg, width, height, needRefresh, format) {
  let avalue;
  format = format || 'gif';
  try {
    avalue = decodeURI(value)
  } catch (e) {
    avalue = value;
  }

  // avalue = encodeURI(avalue);
  if (String(avalue).indexOf('base64') != -1) return avalue;
  if (!avalue || avalue==='null') {
    if (defaultImg) {
      return defaultImg;
    } else {
      return "/static/sample/avatar.png";
    }
  }
  if (needRefresh) {
    const time = new Date(formatDate(Date.now(), "YYYY-MM-DD")).getTime();
    if (avalue.indexOf("?") > -1) {
      avalue += `&time=${time}`;
    } else {
      avalue += `?time=${time}`;
    }
  }
  if (avalue.includes("http://") || avalue.includes("https://")) {
    if (avalue.indexOf('manamana') !== -1) {
      if (width && height) {
        if (avalue.includes("?vframe")) {
          const url = avalue.split("?")[0];
          const time = avalue.split("?vframe/jpg/offset/")[1].split('/')[0];
          return `${url}?vframe/jpg/offset/${time}|imageView2/1/w/${width}/h/${height}/format/${format}`
        }
        if (!avalue.includes("/w/")) {
          if (avalue.indexOf('imageMogr2/') > -1) {
            return `${avalue.split('?')[0]}?imageView2/1/w/${width}/h/${height}/format/${format}`;
          } else {
            if (avalue.indexOf("?") > -1) {
              return `${avalue}&imageView2/1/w/${width}/h/${height}/format/${format}/ignore-error/1`;
            } else {
              return `${avalue}?imageView2/1/w/${width}/h/${height}/format/${format}/ignore-error/1`;
            }
          }
        } else {
          let end = avalue.indexOf("/w/");
          let str = avalue.substr(0, end) + `/w/${width}/h/${height}`;
          if (str.includes('video.manamana.net') && str.includes('image.manamana.net')) {
            return str.replace('https://image.manamana.net/', '')
          } else {
            return str
          }
        }
      } else if (width || height && avalue.includes("?vframe")) {
        const url = avalue.split("?")[0];
        const time = avalue.split("?vframe/jpg/offset/")[1].split('/')[0];
        return height ? `${url}?vframe/jpg/offset/${time}/1/h/${height}/format/${format}` : `${url}?vframe/jpg/offset/${time}/1/w/${width}/format/${format}`;
      } else if (!avalue.includes("/w/")) {
        if (avalue.indexOf("?") > -1) {
          return `${avalue}&imageView2/2/w/1920/format/${format}`;
        } else {
          return `${avalue}?imageView2/2/w/1920/format/${format}`;
        }
      }
      return avalue;
    } else {
      return avalue;
    }
  } else if (avalue.indexOf("/uploads/") > -1) {
    let url = `https://www.manamana.net/${avalue}`;
    if (width && height) {
      if (url.indexOf("?") > -1) {
        return `${url}&imageView2/1/w/${width}/h/${height}/format/${format}`;
      } else {
        return `${url}?imageView2/1/w/${width}/h/${height}/format/${format}`;
      }
    } else {
      return url;
    }
  } else {
    let url = `https://image.manamana.net/${avalue}`;
    if (width && height) {
      if (url.indexOf('imageMogr2/') > -1) {
        url = url.split('?')[0];
      }
      if (url.indexOf("?") > -1) {
        return `${url}&imageView2/1/w/${width}/h/${height}/format/${format}`;
      } else {
        return `${url}?imageView2/1/w/${width}/h/${height}/format/${format}`;
      }
    } else {
      return url;
    }
  }
}

export function unImageUrl(value) {
  if (value && (value.indexOf("http://") > -1 || value.indexOf("https://") > -1)) {
    const reg = /.*image.manamana.net\//;
    return value.replace(reg, '');
  } else {
    return value || ''
  }
};
export function secondToDate(result) {
  var h =
    Math.floor(result / 3600) < 10
      ? '0' + Math.floor(result / 3600)
      : Math.floor(result / 3600)
  var m =
    Math.floor((result / 60) % 60) < 10
      ? '0' + Math.floor((result / 60) % 60)
      : Math.floor((result / 60) % 60)
  var s =
    Math.floor(result % 60) < 10
      ? '0' + Math.floor(result % 60)
      : Math.floor(result % 60)
  if (h === '00') {
    return (result = m + ':' + s)
  } else {
    return (result = h + ':' + m + ':' + s)
  }
}
export function richText(val) {
  if (val) {
    let htmlStr = val.replace(/'/g, "`").replace(/"/g, "'");
    return replace(imgUtlreplace(htmlStr), htmlStr);
  }
  function imgUtlreplace(htmlStr) {
    let replaceArr = [];
    htmlStr.replace(/<img\b.*?(?:\>|\/>)/gi, imgHtml => {
      imgHtml.replace(/\bsrc\b\s*=\s*[\'\"]?([^\'\"]*)[\'\"]?/i, src => {
        replaceArr.push(src);
      });
    });
    return replaceArr;
  }
  function replace(arr, str) {
    let returnStr = str;
    for (let i = 0; i < arr.length; i++) {
      const el = arr[i];
      returnStr = returnStr.replace(el, "src=" + src_filter(el));
    }
    return returnStr;
  }
  function src_filter(src) {
    let str = src.split("src='")[1].replace("'", "");
    return imageUrl(str, '', '', '', '', 'gif');
  }
}



// WEBPACK FOOTER //
// ./src/util/filters.js